// ============================================================
// reservationGroup — 複数台予約（枝番 -1, -2 …）のグループと、定型メールの「全台分」への書き換え
// AI の起案（tools.ts）とサイドパネルの定型メール（usePaymentEmail.ts）で共用する（2026-11-03）。
// 2026-10-22: サイドパネルから送ったオファーのメールが、3台の予約に1台分の合計（¥19,940）を書いていた
// ============================================================

import { fetchDispatchReservations } from '../api/dispatchService';

const GROUP_EXCLUDED_STATUSES = new Set(['cancelled', 'nonreserved']);

/**
 * 複数台予約（枝番 -1, -2 …）のグループ（2026-09-30 セッション1532: 2台の予約に1台分の承諾メールを起案。
 * 「代表メールは枝番 -1、全車両分の内容で送る」）。単独予約なら null。
 */
export async function fetchReservationGroup(target: any): Promise<{ codes: string[]; total: number; count: number } | null> {
  const code = String(target?.contact_code ?? '');
  const m = /^(.*)-(\d+)$/.exec(code);
  if (!m || !/^(TR|PI|PT)-/.test(code)) return null;   // 宮古の自社サイトは PI-
  const base = m[1];
  const day = String(target.start_date ?? '').slice(0, 10);
  if (!day) return null;
  const list = await fetchDispatchReservations({ startDate: day, endDate: day });
  const members = (list || [])
    .filter((r: any) => new RegExp(`^${base.replace(/[-]/g, '\\-')}-\\d+$`).test(String(r.contact_code ?? '')))
    .filter((r: any) => !GROUP_EXCLUDED_STATUSES.has(String(r.status_code ?? r.status ?? '')));
  if (members.length < 2) return null;
  members.sort((a: any, b: any) => Number(String(a.contact_code).split('-').pop()) - Number(String(b.contact_code).split('-').pop()));
  const total = members.reduce((acc: number, r: any) => acc + (Number(r.detail?.sum_price ?? r.sum_price) || 0), 0);
  return { codes: members.map((r: any) => String(r.contact_code)), total, count: members.length };
}

/** 定型メール本文を「全台分」に書き換える（予約コードの範囲・台数・グループ合計） */
export function applyGroupToBody(body: string, group: { codes: string[]; total: number; count: number }, carLabel: string): string {
  const range = `${group.codes[0]} 〜 ${group.codes[group.codes.length - 1]}`;
  const yen = `¥${group.total.toLocaleString()}`;
  return body
    .replace(/^(予約コード:\s*).*$/m, `$1${range}（全${group.count}台）`)
    .replace(/^(Reservation Code:\s*).*$/m, `$1${range} (${group.count} vehicles)`)
    .replace(/^合計金額:.*$/m, `車種・台数: ${carLabel} ×${group.count}台\n合計金額（全${group.count}台）: ${yen}`)
    .replace(/^Total:.*$/m, `Vehicles: ${carLabel} x${group.count}\nTotal (${group.count} vehicles): ${yen}`)
    .replace(/^(預約編號:\s*).*$/m, `$1${range}（共${group.count}台）`)
    .replace(/^(예약 코드:\s*).*$/m, `$1${range} (총 ${group.count}대)`)
    .replace(/^總金額:.*$/m, `車種・台數: ${carLabel} ×${group.count}台\n總金額（共${group.count}台）: ${yen}`)
    .replace(/^합계 금액:.*$/m, `차종・대수: ${carLabel} ×${group.count}대\n합계 금액 (총 ${group.count}대): ${yen}`);
}

